import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:svg": "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m8.01,10.38c0.75,0 1.39,-0.26 1.92,-0.79c0.53,-0.53 0.79,-1.17 0.79,-1.92c0,-0.76 -0.26,-1.4 -0.79,-1.93c-0.53,-0.53 -1.17,-0.79 -1.93,-0.79c-0.75,0 -1.39,0.26 -1.92,0.79c-0.53,0.53 -0.79,1.17 -0.79,1.93c0,0.75 0.26,1.4 0.79,1.92c0.53,0.53 1.17,0.79 1.93,0.79zm-0.01,-0.91c-0.5,0 -0.92,-0.18 -1.27,-0.53c-0.35,-0.35 -0.53,-0.77 -0.53,-1.27c0,-0.5 0.18,-0.93 0.53,-1.28c0.35,-0.35 0.77,-0.52 1.27,-0.52c0.5,0 0.93,0.17 1.28,0.52c0.35,0.35 0.52,0.78 0.52,1.28c0,0.5 -0.17,0.92 -0.52,1.27c-0.35,0.35 -0.78,0.53 -1.28,0.53zm0,2.86c-1.53,0 -2.93,-0.42 -4.19,-1.27c-1.26,-0.84 -2.18,-1.97 -2.78,-3.39c0.6,-1.42 1.52,-2.56 2.78,-3.4c1.26,-0.85 2.66,-1.27 4.19,-1.27c1.54,0 2.93,0.42 4.19,1.27c1.26,0.84 2.19,1.98 2.79,3.4c-0.6,1.42 -1.53,2.55 -2.79,3.39c-1.26,0.85 -2.65,1.27 -4.19,1.27zm0,-1c1.26,0 2.41,-0.33 3.46,-0.99c1.05,-0.66 1.85,-1.55 2.41,-2.67c-0.56,-1.13 -1.36,-2.02 -2.41,-2.68c-1.05,-0.66 -2.2,-0.99 -3.46,-0.99c-1.25,0 -2.4,0.33 -3.45,0.99c-1.05,0.66 -1.86,1.55 -2.41,2.68c0.55,1.12 1.36,2.01 2.41,2.67c1.05,0.66 2.2,0.99 3.45,0.99z",
      fill: "#000000",
      id: "visibility_2"
    }, null, -1),
    _createElementVNode("line", {
      fill: "none",
      id: "svg_5",
      stroke: "#000000",
      x1: "2",
      x2: "14",
      y1: "2.5",
      y2: "13.5"
    }, null, -1)
  ])))
}
export default { render: render }